import { trimExtraSpacesStringUtil } from 'utils/string/trim-spaces'

function splitAndTrimAll (str, separator) {
  const arr = str.split(separator)
  return arr.length === 1
    ? arr[0] === '' ? [] : arr.map(trimExtraSpacesStringUtil)
    : arr.map(trimExtraSpacesStringUtil)
}

/**
 * Removes spaces from the string.
 * @param  {string} str The string to modify.
 * @returns {string}     The string without spaces.
 */
function removeSpacesStringUtil (str) {
  return str.replace(/\s+/g, '')
}

/**
 * Removes non-printable characters.
 *
 * @example
 *
 * ```js
 *
 * // Before
 * let keyCode = 8 // Backspace
 * let str     = String.fromCharCode(keyCode)
 * str.length => 1 // Before
 *
 * // After
 * str = removeNonPrintableCharactersStringUtil
 * str.length => 0
 *
 * ```
 *
 * @param  {string} str
 * @returns {string}
 */
function removeNonPrintableCharactersStringUtil (str) {
  return str.replace(/[^ -~]+/g, '')
}

/**
 * Removes the last character of a string if it matches the char passed in
 * parameter.
 * @param  {string} str  The string to modify.
 * @param  {string} phrase The character to match.
 * @returns {string}      The string without the last character if it matches
 *   the char.
 */
function removeEndOfStringMatchStringUtil (str, phrase) {
  if (!str.endsWith(phrase)) {
    return str
  }
  return removeLastCharactersStringUtil(str, phrase.length)
}

/**
 * Removes the last character of a string.
 * @param  {string} str The string to modify.
 * @param  {string} n   The number of characters to remove.
 * @returns {string}     The strig without the last n characters.
 */
function removeLastCharactersStringUtil (str, n) {
  return str.slice(0, str.length - n)
}

/**
 * Replaces the last match in a string.
 * @param  {string} str
 * @param  {string} match
 * @param  {string} newStr
 * @returns {string}
 */
function replaceLastMatchStringUtil (str, match, newStr) {
  const lastIndex = str.lastIndexOf(match)
  return str.slice(0, lastIndex) + str.slice(lastIndex).replace(match, newStr)
}

export {
  removeEndOfStringMatchStringUtil,
  removeNonPrintableCharactersStringUtil,
  removeSpacesStringUtil,
  replaceLastMatchStringUtil,
  splitAndTrimAll
}

export function joinPathsStringUtil (...paths) {
  return paths.join('.')
}
